export const CSSVarHeaderHeight = "var(--header-height)";

/**
 * Maximum width for main content container.
 * Used to determine responsive breakpoints for sticky elements.
 */
export const CONTENT_MAX_WIDTH = "560px";

/**
 * Top position for the modal close button when fixed.
 * This aligns with the stepper's padding to ensure the close button
 * aligns with the back button when scrolling.
 * 24px converted to rem (24px ÷ 16px = 1.5rem)
 */
export const ModalCloseButtonTop = "1.5rem";

/**
 * Stepper positioning constants to avoid magic numbers.
 * These values are used to position the stepper correctly to align the back button with the close modal button.
 */
export const StepperModalModeNegativeMarginTop = "-0.9375rem"; // -15px converted to rem
export const StepperModalModePaddingTop = "1.9375rem"; // 31px converted to rem
export const StepperModalModeStickyTop = "-0.59375rem"; // -9.5px converted to rem
